import { classNames } from "../../helpers/classNames";

const Cards = ({ children, title = "card title", header, description = "card description", bodyClass }) => {
  return (
    <div className="rounded-xl shadow bg-whiteflex flex-col">
      {header !== false && header ? (
        header
      ) : (
        <div className="bg-denim/10 min-h-10 px-4 py-3 rounded-t-xl">
          <div className="font-semibold text-base">{title}</div>
          <div className="text-gray-500 text-xs font-medium">{description}</div>
        </div>
      )}
      <div className={classNames("flex-grow p-4", bodyClass)}>{children}</div>
    </div>
  );
};

export default Cards;
